import Vue from 'vue'

import Vant from 'vant'
import 'vant/lib/index.css'
import 'font-awesome/css/font-awesome.min.css'

import App from './App.vue'
import store from './store'
import router from './router'
import {installNavTracker} from '@/utils/navTracker'
import i18n from './lang'
import {getToken} from '@/utils/auth'

Vue.config.productionTip = false

// 注册 Vant，并接入 i18n
Vue.use(Vant, {
    i18n: (key, value) => i18n.t(key, value)
})

// 任何前端页面访问都要经过此函数过滤，有token的可以继续访问，无token的直接跳转到登录页
const whiteList = ['/login', '/register']  // 不需要登录的页面
router.beforeEach((to, from, next) => {
    const hasToken = getToken()
    if (hasToken) {
        if (to.path === '/' || to.path === '/login') {
            next('/index')
        } else {
            next()
        }
    } else {
        if (whiteList.includes(to.path)) {
            next()
        } else {
            next('/login')
        }
    }
})
installNavTracker(router)
// 全局工具函数（直接从旧项目复制）
Vue.prototype.formatDate = function (timestamp, type = 1) {
    if (timestamp === 0) return ''
    const date = new Date(timestamp * 1000) // 将秒转换为毫秒
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const seconds = date.getSeconds().toString().padStart(2, '0')
    if (type === 1) {
        return `${year}-${month}-${day}`
    } else if (type === 2) {
        return `${year}-${month}-${day} ${hours}:${minutes}`
    } else if (type === 3) {
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
}

Vue.prototype.formatScanUserMsg = function (d) {
    if (!d.operatorName) return ' --- '
    const operatorTime = Vue.prototype.formatDate(d.operatorTime, 2)
    return `${d.operatorName}, ${operatorTime}`
}

Vue.prototype.getFaHuoZuHe = function (d) {
    if (!d) return ''
    const 发货零头 = d.qty1 % d.packagingQty1
    const 发货箱数 = parseInt(d.qty1 / d.packagingQty1)
    if (发货零头 === 0) {
        return `${发货箱数}${d.packagingUnit}整`
    } else {
        return `${发货箱数}${d.packagingUnit}+${发货零头}${d.unit}`
    }
}

Vue.prototype.getMaterialTypeName = function (typeCode) {
    if (typeCode === 0) return '样品件'
    if (typeCode === 1) return '试装件'
    if (typeCode === 2) return '批量件'
    if (typeCode === 3) return '外包装'
}

Vue.prototype.getDeliveryTypeName = function (typeCode) {
    if (typeCode === 0) return '正常发货'
    if (typeCode === 1) return '供应商补发'
    if (typeCode === 2) return '仓库补发'
}

Vue.prototype.getScanResultName = function (typeCode) {
    if (typeCode === 0) return '未扫码'
    if (typeCode === 1) return '已配好'
    if (typeCode === 2) return '库存不足'
    if (typeCode === 3) return '发货超标'
}

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')